// 检查是否支持某样式属性
// 默认检查是否支持position: sticky
function suportStyle(key, value) {
  // 参数检查
  if (key && typeof key !== 'string') {
    throw new Error('the key should be a string')
  }
  if (value && typeof value !== 'string') {
    throw new Error('the value should be a string')
  }
  if (key || value) {
    if (key && typeof value === 'undefined') {
      throw new Error('the value should be a string')
    }
    if (value && typeof key === 'undefined') {
      throw new Error('the key should be a string')
    }
  }
  // 默认检查是否支持position: sticky
  let styleKey = key || 'position'
  let styleValue = value || 'sticky'
  let vendorList = ['', '-webkit-', '-ms-', '-moz-', '-o-']
  let vendorListLength = vendorList.length
  let el = document.createElement('div')

  for (var i = 0; i < vendorListLength; i++) {
    el.style[styleKey] = vendorList[i] + styleValue
    if (el.style.position !== '') {
      return true
    }
  }
  return false
}

export default function scrollFixed(params) {
  let { el, height, top = 0, zIndex = 10 } = params;
  if (suportStyle()) {
    el = el.parentNode

    let fixStyle = `position: -webkit-sticky;position: sticky;top: ${top}px;left: 0px;z-index: ${zIndex};`

    if (typeof height !== 'undefined') {
      fixStyle += `height: ${height}px;`
    }

    el.setAttribute('style', fixStyle)
    return
  }
  const ot = el.offsetTop - top
  const fn = () => {
    const st = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
    let fixStyle = `position: fixed;top: ${top}px;left: 0px;z-index: ${zIndex};`

    if (typeof height !== 'undefined') {
      fixStyle += `height: ${height}px;`
    }

    el.setAttribute('style', st > ot ? fixStyle : '')
  }
  fn()
  document.addEventListener('scroll', fn)
}



// WEBPACK FOOTER //
// ./src/components/xesMallSearch/scrollFixed.js